import { VISITOR_TYPE } from 'src/features/visitor/types';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export const visitorTypeBadgeOptions = {
    [VISITOR_TYPE.PERSON]: {
        label: visitorMessages.person,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
    [VISITOR_TYPE.CAR]: {
        label: visitorMessages.car,
        icon: ICON_MAP.CLIENT,
        theme: 'yellow',
    },
    [VISITOR_TYPE.BUS]: {
        label: visitorMessages.bus,
        icon: ICON_MAP.BUS,
        theme: 'purple',
    },
    [VISITOR_TYPE.TRUCK]: {
        label: visitorMessages.truck,
        icon: ICON_MAP.TRUCK,
        theme: 'green',
    },
    [VISITOR_TYPE.SPECIALISED]: {
        label: visitorMessages.specialised,
        icon: ICON_MAP.DANGER,
        theme: 'gray',
    },
};

export const STAY_PERIODS_PANEL = 'stay-periods-panel';
export const GATEWAY_PASSES_PANEL = 'gateway-passes-panel';
